module.exports = __webpack_public_path__ + "media/assets/booking/btn_login_base-681ab28471d250012b3cf188ea5980e9.png";